export const PublicLayout = ({ children }) => {
	// Aquí puedes agregar el diseño para rutas públicas
	return (
		<div>
			{children}
		</div>
	);
};